/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createTheming } from "@callstack/react-theme-provider";

import { palette } from "./color.palette";

export const themeConfig = {
    colors: {
        mainBackground: palette?.grey,
        mainForeground: palette?.black,

        toastSuccess: palette?.greenDark,
        toastError: palette?.lemonade,

        primary: palette.primary,
        secondary: palette?.lemonade,

        headerBorderColor: palette?.primary,

        primaryCardBackground: palette.swissRed,
        secondaryCardBackground: palette?.white,

        primaryButtonBackground: palette?.lemonade,

        primaryCardText: palette.white,
        secondaryCardText: palette.swissRed,

        primaryText: palette.swissRed,
        secondaryText: palette.white,

        ...palette,
    },
};

const { ThemeProvider, withTheme, useTheme } = createTheming(themeConfig);

export { ThemeProvider, withTheme, useTheme };
